/* Motion Molds — Shopify storefront JS */
/* Cart drawer, popup, gallery, review carousel — adapted to Shopify cart API */

(function () {
  'use strict';

  const fmtMoney = (cents) => {
    const n = (cents / 100).toFixed(2);
    return '$' + n;
  };

  // ──────────────────────────────────────────────
  // CART
  // ──────────────────────────────────────────────
  const Cart = {
    state: null,

    async fetch() {
      const res = await fetch(window.MM.routes.cart, { credentials: 'same-origin' });
      this.state = await res.json();
      return this.state;
    },

    async add(variantId, quantity) {
      quantity = quantity || 1;
      const res = await fetch(window.MM.routes.cart_add + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
      });
      if (!res.ok) throw new Error('Add to cart failed');
      await this.fetch();
      this.render();
      this.open();
      return this.state;
    },

    async change(lineKey, quantity) {
      const res = await fetch(window.MM.routes.cart_change + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      });
      if (!res.ok) throw new Error('Cart update failed');
      this.state = await res.json();
      this.render();
      return this.state;
    },

    render() {
      const body = document.getElementById('cart-drawer-body');
      const foot = document.getElementById('cart-drawer-foot');
      const subEl = document.getElementById('cart-drawer-subtotal-amt');
      if (!body) return;

      // update count
      const count = this.state ? this.state.item_count : 0;
      document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count; });

      if (!this.state || !this.state.items.length) {
        body.innerHTML =
          '<div class="cart-drawer-empty">' +
            '<h4>Your Cart Is Empty.</h4>' +
            '<p>Pick a mold and start training the bottom half.</p>' +
            '<a href="/collections/all-molds">Shop The Molds →</a>' +
          '</div>';
        if (foot) foot.hidden = true;
        return;
      }
      if (foot) foot.hidden = false;

      // free ship bar
      const sub = this.state.items_subtotal_price;
      const FREE_SHIP = (window.MM.free_shipping_threshold || 99) * 100;
      const remaining = Math.max(0, FREE_SHIP - sub);
      const pct = Math.min(100, (sub / FREE_SHIP) * 100);
      const shippingBar = remaining > 0
        ? '<div class="cart-shipping-bar">' +
            '<p>Add <strong>' + fmtMoney(remaining) + '</strong> for free US shipping.</p>' +
            '<div class="cart-shipping-track"><div class="cart-shipping-fill" style="width:' + pct + '%"></div></div>' +
          '</div>'
        : '<div class="cart-shipping-bar">' +
            '<p><span class="check">✓</span>Free US shipping unlocked.</p>' +
            '<div class="cart-shipping-track"><div class="cart-shipping-fill" style="width:100%"></div></div>' +
          '</div>';

      body.innerHTML = shippingBar + this.state.items.map(item =>
        '<div class="cart-item">' +
          '<img src="' + (item.image || '') + '" alt="' + item.product_title + '">' +
          '<div class="cart-item-info">' +
            '<div class="cart-item-name">' + item.product_title + '</div>' +
            '<div class="cart-item-price">' + fmtMoney(item.final_line_price) + '</div>' +
            '<div class="cart-item-qty">' +
              '<button data-line="' + item.key + '" data-qty="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-line="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="cart-item-remove" data-line="' + item.key + '" data-qty="0" aria-label="Remove">×</button>' +
        '</div>'
      ).join('');

      if (subEl) subEl.textContent = fmtMoney(sub);
    },

    open() {
      const overlay = document.getElementById('cart-drawer-overlay');
      const drawer = document.getElementById('cart-drawer');
      if (overlay) overlay.classList.add('visible');
      if (drawer) drawer.classList.add('visible');
      document.documentElement.style.overflow = 'hidden';
    },
    close() {
      const overlay = document.getElementById('cart-drawer-overlay');
      const drawer = document.getElementById('cart-drawer');
      if (overlay) overlay.classList.remove('visible');
      if (drawer) drawer.classList.remove('visible');
      document.documentElement.style.overflow = '';
    },

    bind() {
      // Cart toggle in nav
      document.querySelectorAll('[data-cart-toggle]').forEach(btn => {
        btn.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
      });

      // Close handlers
      const closeBtn = document.getElementById('cart-drawer-close');
      const overlay = document.getElementById('cart-drawer-overlay');
      const drawer = document.getElementById('cart-drawer');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
      if (overlay) overlay.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer && drawer.classList.contains('visible')) this.close();
      });

      // Body delegation: qty + remove
      const body = document.getElementById('cart-drawer-body');
      if (body) {
        body.addEventListener('click', (e) => {
          const line = e.target.dataset && e.target.dataset.line;
          if (!line) return;
          const qty = parseInt(e.target.dataset.qty, 10);
          this.change(line, qty);
        });
      }

      // Checkout
      const checkout = document.querySelector('.cart-drawer-checkout');
      if (checkout) {
        checkout.addEventListener('click', () => { window.location = window.MM.routes.cart_url + '/checkout'; });
      }

      // Add-to-cart forms (Shopify forms)
      document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const id = form.querySelector('[name="id"]').value;
          const qtyInput = form.querySelector('[name="quantity"]');
          const quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
          try { await this.add(id, quantity); }
          catch (err) { console.error(err); alert('Could not add to cart.'); }
        });
      });

      // Quick-add buttons with data-variant-id
      document.querySelectorAll('[data-variant-id]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.add(btn.dataset.variantId, 1);
        });
      });
    }
  };

  // ──────────────────────────────────────────────
  // PRODUCT GALLERY (carousel with thumbs + lightbox)
  // ──────────────────────────────────────────────
  let lightboxState = null;
  const ensureLightbox = () => {
    if (document.getElementById('product-lightbox')) return;
    document.body.insertAdjacentHTML('beforeend',
      '<div class="product-lightbox" id="product-lightbox" role="dialog" aria-modal="true" aria-hidden="true">' +
        '<button class="product-lightbox-close" id="lightbox-close" aria-label="Close">×</button>' +
        '<button class="product-lightbox-nav product-lightbox-nav-prev" id="lightbox-prev" aria-label="Previous">←</button>' +
        '<button class="product-lightbox-nav product-lightbox-nav-next" id="lightbox-next" aria-label="Next">→</button>' +
        '<img class="product-lightbox-img" id="lightbox-img" alt="">' +
        '<div class="product-lightbox-counter" id="lightbox-counter"></div>' +
      '</div>'
    );
    const lb = document.getElementById('product-lightbox');
    document.getElementById('lightbox-close').addEventListener('click', closeLightbox);
    document.getElementById('lightbox-prev').addEventListener('click', (e) => { e.stopPropagation(); if (lightboxState) lightboxState.prev(); });
    document.getElementById('lightbox-next').addEventListener('click', (e) => { e.stopPropagation(); if (lightboxState) lightboxState.next(); });
    lb.addEventListener('click', (e) => { if (e.target === lb) closeLightbox(); });
    document.addEventListener('keydown', (e) => {
      if (!lightboxState) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowRight') lightboxState.next();
      else if (e.key === 'ArrowLeft') lightboxState.prev();
    });
  };
  const openLightbox = (imgs, startIdx, syncParent) => {
    ensureLightbox();
    const lb = document.getElementById('product-lightbox');
    const lbImg = document.getElementById('lightbox-img');
    const lbCounter = document.getElementById('lightbox-counter');
    let idx = startIdx;
    const update = () => {
      lbImg.src = imgs[idx].src;
      lbImg.alt = imgs[idx].alt || '';
      lbCounter.textContent = String(idx + 1).padStart(2, '0') + ' / ' + String(imgs.length).padStart(2, '0');
      syncParent(idx);
    };
    lightboxState = {
      next: () => { idx = (idx + 1) % imgs.length; update(); },
      prev: () => { idx = (idx - 1 + imgs.length) % imgs.length; update(); }
    };
    update();
    lb.classList.add('visible');
    lb.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };
  const closeLightbox = () => {
    const lb = document.getElementById('product-lightbox');
    if (!lb) return;
    lb.classList.remove('visible');
    lb.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    lightboxState = null;
  };
  const initProductGalleries = () => {
    document.querySelectorAll('.product-media').forEach(media => {
      const mainImgs = media.querySelectorAll('.product-media-main img');
      const thumbs = media.querySelectorAll('.product-media-thumb');
      if (mainImgs.length < 2 || thumbs.length < 2) return;
      const main = media.querySelector('.product-media-main');
      const counter = media.querySelector('.product-media-counter');
      const prevBtn = media.querySelector('.product-media-nav-prev');
      const nextBtn = media.querySelector('.product-media-nav-next');
      let activeIdx = 0;
      const pad = (n) => String(n).padStart(2, '0');
      const total = pad(mainImgs.length);
      const setActive = (i) => {
        activeIdx = ((i % mainImgs.length) + mainImgs.length) % mainImgs.length;
        mainImgs.forEach(img => img.classList.remove('active'));
        thumbs.forEach(t => t.classList.remove('active'));
        if (mainImgs[activeIdx]) mainImgs[activeIdx].classList.add('active');
        if (thumbs[activeIdx]) thumbs[activeIdx].classList.add('active');
        if (counter) counter.textContent = pad(activeIdx + 1) + ' / ' + total;
      };
      setActive(0);
      thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', (e) => { e.preventDefault(); setActive(i); });
      });
      if (prevBtn) prevBtn.addEventListener('click', (e) => { e.stopPropagation(); setActive(activeIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', (e) => { e.stopPropagation(); setActive(activeIdx + 1); });
      if (main) {
        main.addEventListener('click', (e) => {
          if (e.target.closest('.product-media-nav')) return;
          openLightbox(mainImgs, activeIdx, setActive);
        });
      }
    });
  };

  // ──────────────────────────────────────────────
  // REVIEW CAROUSELS
  // ──────────────────────────────────────────────
  const initReviewCarousels = () => {
    document.querySelectorAll('.reviews-grid').forEach(grid => {
      const cards = grid.querySelectorAll('.review-card');
      if (cards.length < 2) return;
      let timer;
      const pageCount = () => Math.max(1, Math.ceil(grid.scrollWidth / grid.clientWidth));
      const currentPage = () => Math.round(grid.scrollLeft / grid.clientWidth);
      const dots = document.createElement('div');
      dots.className = 'reviews-dots';
      const rebuildDots = () => {
        dots.innerHTML = '';
        const pages = pageCount();
        for (let i = 0; i < pages; i++) {
          const btn = document.createElement('button');
          btn.setAttribute('aria-label', 'Page ' + (i + 1));
          btn.addEventListener('click', () => { goToPage(i); restart(); });
          if (i === 0) btn.classList.add('active');
          dots.appendChild(btn);
        }
      };
      rebuildDots();
      grid.insertAdjacentElement('afterend', dots);
      const goToPage = (i) => { grid.scrollTo({ left: i * grid.clientWidth, behavior: 'smooth' }); };
      const advance = () => { goToPage((currentPage() + 1) % pageCount()); };
      const restart = () => { clearInterval(timer); timer = setInterval(advance, 15000); };
      grid.addEventListener('mouseenter', () => clearInterval(timer));
      grid.addEventListener('mouseleave', restart);
      grid.addEventListener('scroll', () => {
        const p = currentPage();
        Array.from(dots.children).forEach((d, i) => d.classList.toggle('active', i === p));
      }, { passive: true });
      window.addEventListener('resize', () => { rebuildDots(); });
      restart();
    });
  };

  // ──────────────────────────────────────────────
  // STICKY ADD-TO-CART
  // ──────────────────────────────────────────────
  const initStickyCart = () => {
    const stickyCart = document.getElementById('sticky-cart');
    const productInfo = document.querySelector('.product-info');
    if (!stickyCart || !productInfo) return;
    const onScroll = () => {
      const rect = productInfo.getBoundingClientRect();
      if (rect.bottom < 0) stickyCart.classList.add('visible');
      else stickyCart.classList.remove('visible');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  // ──────────────────────────────────────────────
  // NEWSLETTER POPUP
  // ──────────────────────────────────────────────
  const initPopup = () => {
    const KEY = 'mm_popup_dismissed';
    if (localStorage.getItem(KEY)) return;
    const overlay = document.getElementById('popup-overlay');
    if (!overlay) return;
    const close = () => {
      overlay.classList.remove('visible');
      overlay.setAttribute('aria-hidden', 'true');
      localStorage.setItem(KEY, '1');
    };
    document.getElementById('popup-close').addEventListener('click', close);
    const decline = document.getElementById('popup-decline');
    if (decline) decline.addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && overlay.classList.contains('visible')) close(); });
    const delay = parseInt(overlay.dataset.delay || '6', 10) * 1000;
    setTimeout(() => {
      overlay.classList.add('visible');
      overlay.setAttribute('aria-hidden', 'false');
    }, delay);
  };

  // ──────────────────────────────────────────────
  // QTY CONTROL (PDP)
  // ──────────────────────────────────────────────
  const initQty = () => {
    document.querySelectorAll('.qty-control').forEach(ctrl => {
      const input = ctrl.parentNode.querySelector('input[name="quantity"]') || ctrl.querySelector('span');
      const display = ctrl.querySelector('span');
      ctrl.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const delta = btn.dataset.delta === '-1' ? -1 : 1;
          const cur = parseInt(display.textContent, 10) || 1;
          const next = Math.max(1, cur + delta);
          display.textContent = next;
          if (input && input !== display) input.value = next;
        });
      });
    });
  };

  // ──────────────────────────────────────────────
  // INIT
  // ──────────────────────────────────────────────
  const init = async () => {
    Cart.bind();
    try { await Cart.fetch(); Cart.render(); } catch (e) { /* ignore */ }
    initProductGalleries();
    initReviewCarousels();
    initStickyCart();
    initPopup();
    initQty();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
